export interface PollAudience {
    allClientsInPoll: boolean;
    allEmployeesInPoll: boolean;
    participantUuids: unknown[];
}

export const hasPollAudience = (poll: PollAudience): boolean => {
    return poll.allClientsInPoll || poll.allEmployeesInPoll || poll.participantUuids.length > 0;
};
